/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import '../../home-style.scss'
import { fetchGraphV2aggr } from '../../../../services/api'
import dayjs from 'dayjs'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import IconButton from '@mui/material/IconButton'
import useEnergyGraphStyles from './styles'
import EnergyGraphFilter from '../EnergyGraphFilter/EnergyGraphFilter'
import EnergyGraphContainer from '../EnergyGraphContainer/EnergyGraphContainer'

const EnergyGraph = ({ token }) => {
  const [technicalFromDate, setTechnicalFromDate] = React.useState(
    dayjs(new Date()).subtract(29, 'day')
  )
  const [technicalToDate, setTechnicalToDate] = React.useState(
    dayjs(new Date())
  )
  const [totalEnergygraphDuration, settTotalEnergyGraphDuration] =
    useState('1m')
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)
  const [mapTotalenergySeries, setMapTotalenergySeries] = React.useState([])

  const [graphTotalType] = useState('etoday')
  const [open, setOpen] = useState(false)
  const [openTable, setOpenTable] = useState(false)
  const [isData, setIsData] = useState(false)

  const classes = useEnergyGraphStyles()
  const chartRef = useRef(null)
  // const [chartRef, setChartRef] = useState(null);

  // Update screen size when the component mounts and when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight)
    }

    // Attach the resize event listener
    window.addEventListener('resize', handleResize)

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleGraphupdateOptions = (newOptions) => {
    setChartData((prevOptions) => ({
      ...prevOptions,
      options: {
        ...prevOptions.options,
        xaxis: { ...newOptions.xaxis }, // Merge xaxis options
        tooltip: { ...newOptions.tooltip }, // Merge tooltip options
      },
    }))
  }

  useEffect(() => {
    handleTotalenergyGraph('etoday', '1m')
  }, [])

  useEffect(() => {
    handleTotalenergyGraph('etoday', totalEnergygraphDuration)
  }, [technicalFromDate, technicalToDate])

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  const [chartData, setChartData] = useState({
    series: [
      {
        name: 'Net Profit',
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        zoom: {
          enabled: false,
        },
        toolbar: {
          export: {
            csv: {
              filename: 'TotalEnergy',
              columnDelimiter: ',',
              headerCategory: 'Date',
              headerValue: 'value',
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString()
              },
            },
            svg: {
              filename: 'TotalEnergy',
            },
            png: {
              filename: 'TotalEnergy',
            },
          },
        },
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },

      fill: {
        colors: ['#5968B7'],
        gradient: {
          type: 'vertical',
          shadeIntensity: 0.5,
          gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 0,
          stops: [0, 100],
          colorStops: [],
        },
      },
      xaxis: {
        type: 'category',
        floating: false,
        tickAmount: 15,
        tickPlacement: 'on',
        labels: {
          show: true,
          rotate: -45,
          rotateAlways: true,
          hideOverlappingLabels: true,
          showDuplicates: false,
          trim: false,
          minHeight: undefined,
          maxHeight: 120,
          style: {
            colors: [],
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 400,
            cssClass: 'apexcharts-xaxis-label',
          },
          offsetX: 0,
          offsetY: 0,
          format: 'dd/MM',
          formatter: function (value, timestamp, opts) {
            return dayjs(value).format('DD-MM')
          },
          datetimeUTC: false,
          datetimeFormatter: {
            year: 'yyyy',
            month: "MMM 'yy",
            day: 'dd MMM',
            hour: 'HH:mm',
          },
        },
        tooltip: {
          enabled: true,
          formatter: function (value, opts) {
            return dayjs(
              opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].x
            ).format('DD-MMMM-YY')
          },
          offsetY: 0,
        },
      },
      tooltip: {
        enabled: true,
        x: {
          show: true,
          format: 'dd MMM',
          formatter: function (value, opts) {
            return dayjs(
              opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].x
            ).format('DD-MMMM')
          },
        },
      },
    },
  })
  const handleChooseDate = (value, type) => {
    let subtraction
    let subType

    switch (totalEnergygraphDuration) {
      case 'year':
        subtraction = 11
        subType = 'month'
        break
      case '1m':
        subtraction = 1
        subType = 'month'
        break
      case '3m':
        subtraction = 2
        subType = 'month'
        break
      case '6m':
        subtraction = 5
        subType = 'month'
        break
      case 'mtd':
        subtraction = 0
        subType = 'month'
        break
      case 'ytd':
        subtraction = 0
        subType = 'month'
        break
      case 'day':
        subtraction = 0
        subType = 'month'
        break
      case 'custom':
        subtraction = 0
        subType = 'month'
        break
      default:
        break
    }
    if (type === 'from') {
      if (totalEnergygraphDuration === 'custom') {
        setTechnicalFromDate(value)
      } else {
        const yearData = dayjs(value).add(subtraction, subType)
        setTechnicalFromDate(value)
        const currentDate1y = dayjs()
        const isFuture1y = yearData.isAfter(currentDate1y)
        if (isFuture1y) {
          const previous1yData = dayjs(dayjs(new Date())).subtract(
            subtraction,
            subType
          )
          setTechnicalFromDate(previous1yData)
          setTechnicalToDate(dayjs(new Date()))
        } else {
          setTechnicalToDate(dayjs(new Date()))
        }
      }
    } else if (type === 'to') {
      if (totalEnergygraphDuration === 'custom') {
        setTechnicalToDate(value)
      } else {
        const yearData = dayjs(value).subtract(subtraction, subType)
        setTechnicalFromDate(yearData)
        setTechnicalToDate(dayjs(new Date()))
      }
    }
  }

  const handleTotalenergyGraph = async (type, duration) => {
    settTotalEnergyGraphDuration(duration)
    let graphName
    let TechnicalFromDate
    let TechnicalTodate
    let apiDuration;
      switch (duration) {
        case '1m':
          apiDuration = '1m';
          break;
        case '3m':
          apiDuration = '3m';
          break;
        case '6m':
          apiDuration = '6m';
          break;
        case 'year':
          apiDuration = '1y';
          break;
        case 'ytd':
          apiDuration = 'ytd';
          break;
        case 'custom':
          apiDuration = 'custom';
          break;
        case 'mtd':
          apiDuration = 'mtd';
          break;
        default:
          apiDuration = '1m';
      }
    switch (type) {
      case 'etoday':
        graphName = 'etoday'
        break
      default:
        break
    }
    setIsData(false)

    const todaydate = duration === 'custom' ? technicalFromDate : dayjs(new Date());
    const fromDateFormatted = todaydate.format('YYYY-MM-DD');
    console.log("FROMDATEFORMATTED for", type, ":", fromDateFormatted);
    
    const toDateParam = duration === 'custom' 
      ? technicalToDate.format('YYYY-MM-DD') 
      : 'all';

    const data = await fetchGraphV2aggr(
      graphName,
      fromDateFormatted,
      apiDuration,
      token,
      toDateParam
    );

    const newEnergyData = data.map((obj) => ({
      x: obj.x,
      y: Number(parseFloat(obj.y).toFixed(1)),
    }));

    setIsData(true);
    setMapTotalenergySeries([
      {
        name: 'Total Energy',
        data: newEnergyData,
      },
    ]);
  } 

  return (
    <div className={classes.root}>
      <div
        className="graph_bg"
        style={{ minHeight: '510px', backgroundColor: 'white' }}
      >
        <Dialog fullScreen open={open} onClose={handleClose}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogTitle></DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div className="graph_bg">
                <EnergyGraphFilter
                  totalEnergygraphDuration={totalEnergygraphDuration}
                  mapTotalenergySeries={mapTotalenergySeries}
                  setTechnicalFromDate={setTechnicalFromDate}
                  setTechnicalToDate={setTechnicalToDate}
                  handleTotalenergyGraph={handleTotalenergyGraph}
                  chartRef={chartRef}
                  graphTotalType={graphTotalType}
                  setOpenTable={setOpenTable}
                  handleChooseDate={handleChooseDate}
                  technicalToDate={technicalToDate}
                  technicalFromDate={technicalFromDate}
                  handleOpen={handleOpen}
                  openTable={openTable}
                  handleGraphupdateOptions={handleGraphupdateOptions}
                />
                <EnergyGraphContainer
                  openTable={openTable}
                  mapTotalenergySeries={mapTotalenergySeries}
                  chartData={chartData}
                  chartRef={chartRef}
                  isData={isData}
                  totalEnergygraphDuration={totalEnergygraphDuration}
                />
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <EnergyGraphFilter
          totalEnergygraphDuration={totalEnergygraphDuration}
          mapTotalenergySeries={mapTotalenergySeries}
          setTechnicalFromDate={setTechnicalFromDate}
          setTechnicalToDate={setTechnicalToDate}
          handleTotalenergyGraph={handleTotalenergyGraph}
          chartRef={chartRef}
          graphTotalType={graphTotalType}
          setOpenTable={setOpenTable}
          handleChooseDate={handleChooseDate}
          technicalToDate={technicalToDate}
          technicalFromDate={technicalFromDate}
          handleOpen={handleOpen}
          openTable={openTable}
          handleGraphupdateOptions={handleGraphupdateOptions}
        />
        <EnergyGraphContainer
          openTable={openTable}
          mapTotalenergySeries={mapTotalenergySeries}
          chartData={chartData}
          chartRef={chartRef}
          isData={isData}
          totalEnergygraphDuration={totalEnergygraphDuration}
        />
      </div>
    </div>
  )
}

EnergyGraph.propTypes = {}

export default EnergyGraph
